import React from "react";

import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  InTransitRollSkuPrintInputBean,
  InTransitRollSkuPrintInputCriteria,
  MultiInTransitRollSkuEntityPrintRequest,
  PageListBean,
  PurchaseOrderInTransitRollLineSearchCriteria,
  PurchaseOrderInTransitSearchCriteria,
  PurchaseOrderSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestPurchaseOrderInTransitListRequest,
  RestPurchaseOrderListRequest,
  RestReadRequest,
  SKUBatchInventoryBean,
} from "../ds/ds.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PurchaseOrderInTransitLookupHandler } from "../lookup/PurchaseOrderInTransitLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import {
  PopupFabricStyleModule,
  PopupPurchaseInTransitModule,
  PopupPurchaseOrderModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { PurchaseOrderInTransitService } from "../services/PurchaseOrderInTransitService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { ReportService } from "../services/ReportService.js";
import { BaseInquiryToolBar } from "./BaseModule.js";
class PrintRollForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      pageTitle: "Print PO InTransit Roll",
      error_list: [],
      inquiryDataList: [],
      selectedRollSkuList: [],
      colorList: [],
      criteria: new PurchaseOrderInTransitRollLineSearchCriteria(),
      inventoryData: new SKUBatchInventoryBean(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      alertMsg: "",
      success_list: [],
      moduleForPopup: [],
      roll_criteria: new InTransitRollSkuPrintInputCriteria(),
      colorLookupHandler: null,
      isShowColorLookup: false,
      isShowExitButton: true,
      isDisabledFields: false,
      isShowLookup: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePoIntransitList: false,
      poIntransitPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowPurchaseOrderModule: false,
      isShowFabricStyleModule: false,
      isShowPurchaseOrderInTransitModule: false,
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.initLookupHandlers();
    let roll_criteria = this.state.roll_criteria;
    roll_criteria.noOfCopies = 1;
    this.setState({
      roll_criteria: roll_criteria,
    });
  }
  initLookupHandlers = () => {
    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "Purchase Order"
    );
    this.setState({ purchaseOrderLookupHandler: purchaseOrderLookupHandler });

    let purchaseInTransitLookupHandler =
      new PurchaseOrderInTransitLookupHandler(
        this.companyCode,
        "Purchase InTransit"
      );
    this.setState({
      purchaseInTransitLookupHandler: purchaseInTransitLookupHandler,
    });

    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  rollOnChange = (e) => {
    let roll_criteria = this.state.roll_criteria;
    roll_criteria["noOfCopies"] = e.target.value;
    this.setState({ roll_criteria: roll_criteria });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  onPurchaseOrderChange = (e) => {
    let purchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompletePurchaseOrderList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
    if (isEmpty(purchaseOrderNumber)) {
      this.state.isShowAutoCompletePurchaseOrderList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
      let criteria = this.state.criteria;
      criteria.purchaseOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        purchaseOrderPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderNumber !== ""
    ) {
      this.readPurchaseOrderBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readPurchaseOrderBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.errorCallBack
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (response.data.purchaseOrderPageList != null) {
      if (purchaseorderData.length > 0 && purchaseorderData != null) {
        purchaseorderData.map((po) => {
          let simpleItemBean = {
            code: po.code,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
    }
    this.setState({
      purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    let poCode = e.target.value;
    this.readPurchaseOrder(poCode);
    this.setState({
      purchaseOrderPageListForAutoCompleteList: new Array(),
    });
  };
  readPurchaseOrder = (purchaseOrderCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading PurchaseOrder ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    PurchaseOrderService.initPurchaseOrderModule(
      readrestInput,
      this.readPurchaseOrderResponse,
      this.errorCallBack
    );
  };
  readPurchaseOrderResponse = (response) => {
    if (response.data != null && response.data.purchaseOrderResponse != null) {
      if (!isEmptyArray(response.data.purchaseOrderResponse.purchaseOrder)) {
        let poBean = response.data.purchaseOrderResponse.purchaseOrder;
        let criteria = this.state.criteria;
        criteria.purchaseOrderNumber = poBean.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePurchaseOrderList: showAutoCompleteList,
    });
  };
  poIntransitOnChange = (e) => {
    let purchaseOrderInTransitNumber = e.target.value;
    this.state.isShowAutoCompletePoIntransitList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompletePoIntransitList;
    if (isEmpty(purchaseOrderInTransitNumber)) {
      this.state.isShowAutoCompletePoIntransitList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePoIntransitList;
      let tempCriteria = this.state.criteria;
      tempCriteria.purchaseOrderInTransitNumber = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        criteria: tempCriteria,
        poIntransitPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderInTransitNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderInTransitNumber !== ""
    ) {
      this.readPOIntransitBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: tempCriteria });
  };
  poIntransitEnterKeyEventHandler = (e) => {
    let purchaseOrderInTransitNumber = e.target.value;
    this.readPurchaseInTransit(purchaseOrderInTransitNumber);
    this.state.isShowAutoCompletePoIntransitList = false;
    let showAutoCompleteList = this.state.isShowAutoCompletePoIntransitList;
    this.setState({
      poIntransitPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayPOIntransitAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePoIntransitList: isShowAutoCompleteList,
    });
  };
  readPOIntransitBySearchString = (poIntransitNumber) => {
    let inTransitCriteria = new PurchaseOrderInTransitSearchCriteria();
    inTransitCriteria.companyCode = this.companyCode;
    inTransitCriteria.purchaseOrderInTransitNumberStartsWith =
      poIntransitNumber;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = 1;
    let requestInput = new RestPurchaseOrderInTransitListRequest();
    requestInput.pageInput = pageInput;
    requestInput.searchCriteria = inTransitCriteria;
    PurchaseOrderInTransitService.getPurchaseOrderInTransitPageList(
      requestInput,
      this.loadPurchaseOrderInTransitResponse,
      this.errorCallBack
    );
  };
  loadPurchaseOrderInTransitResponse = (response) => {
    if (response.data != null && response.data.inTransitPageListBean != null) {
      if (
        !isEmpty(response.data.inTransitPageListBean.purchaseOrderinTransits)
      ) {
        let purchaseOrderInTransitListData =
          response.data.inTransitPageListBean.purchaseOrderinTransits;
        let simpleAutoCompleteList = new Array();
        if (
          purchaseOrderInTransitListData.length > 0 &&
          purchaseOrderInTransitListData != null
        ) {
          purchaseOrderInTransitListData.map((obj) => {
            let simpleItemBean = {
              code: obj.code,
              description: "",
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          poIntransitPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    }
  };
  readPurchaseInTransit = (purchaseInTransitCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Fields ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseInTransitCode;
    PurchaseOrderInTransitService.initPurchaseOrderInTransitModule(
      readrestInput,
      this.readPurchaseOrderInTransitResponse,
      this.errorCallBack
    );
  };
  readPurchaseOrderInTransitResponse = (response) => {
    if (
      response.data != null &&
      response.data.purchaseOrderInTransitResponse != null
    ) {
      let ptBean = new Array();
      if (
        !isEmptyArray(
          response.data.purchaseOrderInTransitResponse.purchaseOrderinTransit
        )
      ) {
        ptBean =
          response.data.purchaseOrderInTransitResponse.purchaseOrderinTransit;
        let criteria = this.state.criteria;
        criteria.purchaseOrderInTransitNumber = ptBean.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  loadPage = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (
      !isEmptyString(criteria.fabricStyleCode) ||
      !isEmptyString(criteria.purchaseOrderNumber) ||
      !isEmptyString(criteria.purchaseOrderInTransitNumber)
    ) {
      this.loadRollSkuInquiryList(criteria);
    } else {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "PO# or PO InTransit# or Fabric Style is required!";
      } else {
        errMsg = "PO# or PO InTransit# or Item is required!";
      }
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadRollSkuInquiryList = (criteria) => {
    if (
      SecurityAccessManager.PrintInTransitRollSKUBarCodeMaintenance_IsAccessible()
    ) {
      PurchaseOrderInTransitService.getPurchaseOrderInTransitRollPageList(
        criteria,
        this.loadRollSkuInquiryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadRollSkuInquiryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    let resultList = new Array();
    if (response.data != null && response.data.pageList != null) {
      if (
        !isEmptyArray(response.data.pageList.purchaseOrderInTransitRollLines)
      ) {
        resultList = response.data.pageList.purchaseOrderInTransitRollLines;
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: resultList,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookup: false,
        isShowColorLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };
  colorLotList = (e) => {
    if (e.detail == 1) {
      let inquiryDataList = this.state.inquiryDataList;
      let dataList = [];
      inquiryDataList
        .sort((a, b) => a.colorCode.localeCompare(b.colorCode))
        .map((list) => {
          dataList.push(list);
        });
      dataList.sort((a, b) => a.vendorLotNumber - b.vendorLotNumber);
      this.setState({ inquiryDataList: dataList });
    }
  };
  lineSelectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isActive = true;
      });
      this.setState({ selectedRollSkuList: list });
    }
  };
  lineUnSelectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isActive = false;
      });
      this.setState({ selectedRollSkuList: [] });
    }
  };

  generatePDF = (e) => {
    if (e.detail == 1) this.generateMultiPrint(1);
  };
  generateMultiPrint = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let selectedRollSkuList = this.state.selectedRollSkuList;
    let rollSkuList = [];
    for (let list of selectedRollSkuList) {
      let inputBean = new InTransitRollSkuPrintInputBean();
      inputBean.rollSkuNumber = list.rollSkuNumber;
      inputBean.inTransitNumber = list.purchaseOrderInTransitNumber;
      rollSkuList.push(inputBean);
    }
    let roll_criteria = new InTransitRollSkuPrintInputCriteria();
    roll_criteria.companyCode = this.companyCode;
    roll_criteria.rollSkuList = rollSkuList;
    roll_criteria.noOfCopies = this.state.roll_criteria.noOfCopies;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new MultiInTransitRollSkuEntityPrintRequest();
    listRequest.companyCode = this.companyCode;
    listRequest.criteria = roll_criteria;
    listRequest.reportBean = reportBean;
    if (!isEmptyArray(rollSkuList)) {
      this.hideAlertCallBack();
      if (
        SecurityAccessManager.PrintInTransitRollSKUBarCodePDFReport_IsAccessible()
      ) {
        ReportService.generateMultiInTransitRollSkuEntityPrintReport(
          listRequest,
          this.generateMultiPrintResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else {
      let errMsg = "Select the Line";
      let error_list = [];
      error_list.push(errMsg);
      this.setState({
        alertMessage: error_list,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  generateMultiPrintResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.loadPage();
    this.setState({
      selectedRollSkuList: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  rollLineCheck = (val, rowData) => {
    let selectedLine = [];
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      this.setState({ selectedRollSkuList: selectedLine });
    } else {
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let rollList = [];
      for (let roll of selectedRollSkuList) {
        if (roll.isActive != rowData.isActive) {
          rollList.push(roll);
          this.setState({ selectedRollSkuList: rollList });
        } else if (selectedRollSkuList.length == 1) {
          this.setState({ selectedRollSkuList: [] });
        }
      }
    }
  };
  viewPOModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseOrderModule: true,
        moduleForPopup: (
          <PopupPurchaseOrderModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowPurchaseOrderModule: isOpen,
      isShowFabricStyleModule: isOpen,
      isShowPurchaseOrderInTransitModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewFabricModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricStyleModule: true,
        moduleForPopup: (
          <PopupFabricStyleModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  lnkPOIntransitModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseOrderInTransitModule: true,
        moduleForPopup: (
          <PopupPurchaseInTransitModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.rollLineCheck
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        1
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PurchaseNumber",
        "purchaseOrderNumber",
        0,
        true,
        this.viewPOModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PurchaseInTransit#",
        "purchaseOrderInTransitNumber",
        0,
        true,
        this.lnkPOIntransitModule
      )
    );
    if (this.state.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "Item",
          "fabricStyleCode",
          0,
          true,
          this.viewFabricModule
        )
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyle",
          "fabricStyleCode",
          0,
          true,
          this.viewFabricModule
        )
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails("Name", "fabricStyleName")
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails("Color", "colorCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("VendorLot#", "vendorLotNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Roll#", "rollNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Width", "widthCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Qty#", "inTransitQuantity", 1)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UOM", "uomCode")
    );

    return columnList;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new PurchaseOrderInTransitRollLineSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    let roll_criteria = new InTransitRollSkuPrintInputCriteria();
    roll_criteria.noOfCopies = 1;
    this.setState({
      criteria: tempCriteria,
      roll_criteria: roll_criteria,
      isInquiryDatasFound: false,
      isShowColorLookup: false,
      colorList: [],
    });
  };
  resetView = () => {
    let criteria = new PurchaseOrderInTransitRollLineSearchCriteria();
    criteria.companyCode = this.companyCode;
    let roll_criteria = new InTransitRollSkuPrintInputCriteria();
    roll_criteria.noOfCopies = 1;
    this.setState({
      criteria: criteria,
      roll_criteria: roll_criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowLookup: true,
      isShowColorLookup: false,
      fabricStyleData: new Array(),
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisabledFields: false,
      colorList: [],
    });
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          onModuleExit={this.moduleExit}
          reset={this.resetView}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          rollOnChange={this.rollOnChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          onPurchaseOrderChange={this.onPurchaseOrderChange}
          purchaseOrderEnterKeyEventHandler={
            this.purchaseOrderEnterKeyEventHandler
          }
          displayAutoCompletePurchaseOrderList={
            this.displayAutoCompletePurchaseOrderList
          }
          poIntransitOnChange={this.poIntransitOnChange}
          poIntransitEnterKeyEventHandler={this.poIntransitEnterKeyEventHandler}
          displayPOIntransitAutoCompleteList={
            this.displayPOIntransitAutoCompleteList
          }
        />

        {!isEmptyArray(this.state.inquiryDataList) && (
          <Row>
            <Col sm="1">
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.lineSelectAll(e)}
              >
                SelectAll
              </Button>
            </Col>
            <Col sm="1">
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.lineUnSelectAll(e)}
              >
                UnSelectAll
              </Button>{" "}
            </Col>
            <Col sm="1">
              {" "}
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.generatePDF(e)}
              >
                MultiPrint
              </Button>{" "}
            </Col>
            <Col sm="1">
              {" "}
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.colorLotList(e)}
              >
                Color/lot
              </Button>{" "}
            </Col>
          </Row>
        )}
        {this.state.isInquiryDatasFound && (
          <div className="div_Custom_4">
            <EditableDataGrid
              columnsList={this.columnDefinitions()}
              dataList={inquiryDataList}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderInTransitModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const rollOnChange = (e) => props.rollOnChange(e);
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const purchaseOrderEnterKeyEventHandler = (e) => {
    props.purchaseOrderEnterKeyEventHandler(e);
  };
  const displayAutoCompletePurchaseOrderList = () => {
    props.displayAutoCompletePurchaseOrderList();
  };
  const onPurchaseOrderChange = (e) => {
    props.onPurchaseOrderChange(e);
  };
  const poIntransitEnterKeyEventHandler = (e) => {
    props.poIntransitEnterKeyEventHandler(e);
  };
  const displayPOIntransitAutoCompleteList = () => {
    props.displayPOIntransitAutoCompleteList();
  };
  const poIntransitOnChange = (e) => {
    props.poIntransitOnChange(e);
  };
  let criteria = props.criteria;
  let roll_criteria = props.roll_criteria;
  let fabricCodeRef = React.createRef();
  let colorCodeRef = React.createRef();
  let purchaseCodeRef = React.createRef();
  let inTransitCodeRef = React.createRef();
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>CompanyCode</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="companyCode"
            onChange={onChange}
            value={criteria.companyCode}
            readOnly={true}
          />
        </Col>

        <Col sm="1">
          {" "}
          <FormLabel>PurchaseOrder</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={purchaseCodeRef}
            onChange={onPurchaseOrderChange}
            disabled={props.isDisabledFields}
            name="purchaseOrderNumber"
            placeholder="purchaseOrderNumber"
            value={criteria.purchaseOrderNumber}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.purchaseOrderLookupHandler}
            enterKeyEventHandler={purchaseOrderEnterKeyEventHandler}
            autoCompleteListData={
              props.purchaseOrderPageListForAutoCompleteList
            }
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompletePurchaseOrderList}
            showAutoCompleteList={props.isShowAutoCompletePurchaseOrderList}
            isMandatory={true}
          />
        </Col>

        <Col sm="1">
          <FormLabel>Purchase InTransit</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={inTransitCodeRef}
            onChange={poIntransitOnChange}
            placeholder="purchaseOrderInTransitNumber"
            name="purchaseOrderInTransitNumber"
            value={criteria.purchaseOrderInTransitNumber}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.purchaseInTransitLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={poIntransitEnterKeyEventHandler}
            autoCompleteListData={props.poIntransitPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayPOIntransitAutoCompleteList}
            showAutoCompleteList={props.isShowAutoCompletePoIntransitList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>

        <Col sm="1">
          <FormLabel>LotNumber</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="vendorBatchNumber"
            onChange={onChange}
            value={criteria.vendorBatchNumber}
            disabled={props.isDisabledFields}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            name="colorCode"
            onChange={onFabricColourCodeChange}
            value={criteria.colorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={!props.isShowColorLookup}
          />
        </Col>

        <Col sm="1">
          {" "}
          <FormLabel>Width</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="widthCode"
            onChange={onChange}
            value={criteria.widthCode}
            disabled={props.isDisabledFields}
          />
        </Col>

        <Col sm="1">
          {" "}
          <FormLabel>NumberOf Copies</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={rollOnChange}
            name="noOfCopies"
            value={roll_criteria.noOfCopies}
            disabled={props.isDisabledFields}
          />
        </Col>
      </Row>
    </div>
  );
}
function PrintPOInTransitRollModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div className="App">
        <PrintRollForm {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default PrintPOInTransitRollModule;
